import { boolean, defineAction, object, string } from '~/prix'
import systemImportPostgresDumpAction from './systemImportPostgresDump.action.json'

const systemImportPostgresDumpDefinition = defineAction({
  ...systemImportPostgresDumpAction,
  input: object({
    table: string(),
    schema: string(),
    force: boolean(),
    dataOnly: boolean().isOptional(),
    file: string(),
  }),
  output: object({}),
})

export default systemImportPostgresDumpDefinition
